module.exports = __webpack_public_path__ + "static/img/1-0.e611ee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/science/1-0.png
// module id = YC5K
// module chunks = 15